import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import Colorlogowithbackground from 'assets/icons/Colorlogo-nobackground.png';
import { useSelector } from 'react-redux';
import { selectUser } from 'features/userSlice';

const useStyles = createUseStyles((theme) => ({
    container: ({ collapsed }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        transition: 'all 0.15s ease-out'
    }),
    userRoleContainer: ({ collapsed }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        position: 'relative',
        marginBottom: collapsed ? 0 : 8,
        transition: 'all 0.15s ease-out'
    }),
    userRole: ({ collapsed }) => ({
        fontSize: '10px',
        fontWeight: 'bold',
        color: '#fff',
        opacity: collapsed ? 0 : 0.8,
        transition: 'opacity 0.15s ease-out',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        textAlign: 'center'
    }),
    logoRow: ({ collapsed }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    }),
    title: ({ collapsed }) => ({
        ...theme.typography.cardTitle,
        color: '#fff',
        opacity: collapsed ? 0 : 0.7,
        marginLeft: collapsed ? 0 : 12,
        transition: 'opacity 0.15s ease-out',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    }),
    logoImage: ({ collapsed }) => ({
        // width: 50,
        height: 100,
        aspectRatio: 50 / 80,
        transition: 'all 0.15s ease-out'
    })
}));

function LogoComponent({ collapsed = false }) {
    const theme = useTheme();
    const user = useSelector(selectUser);
    const classes = useStyles({ theme, collapsed });

    const getUserRoleDisplay = () => {
        if (user.role === 'admin') return 'Admin Panel';
        if (user.role === 'agent') return 'Agent Panel';
        return 'ADL Panel';
    };

    return (
        <div className={classes.container}>
            <div className={classes.userRoleContainer}>
                <div className={classes.userRole}>{getUserRoleDisplay()}</div>
            </div>
            <div className={classes.logoRow}>
                <img src={Colorlogowithbackground} className={classes.logoImage} alt='ADL Logo' />
                {/* <span className={classes.title}>ADL</span> */}
            </div>
        </div>
    );
}

export default LogoComponent;
